import { render, staticRenderFns } from "./CAJG1050.vue?vue&type=template&id=4c166b7e&scoped=true"
import script from "./CAJG1050Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAJG1050Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CAJG1050.vue?vue&type=style&index=0&id=4c166b7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c166b7e",
  null
  
)

export default component.exports